<template>
  <Modal
  v-model="isShow"
  :width="800"
  :loading="loading"
  :mask-closable="false"
  @on-ok="ok"
  @on-cancel="cancel"
  >
    <h3>新增活动</h3>
    <Form 
        style="margin-top:24px"
        ref="searchData"
        :model="searchData" 
        :rules="ruleValidate"
        :label-width="100">
      <Row>
        <Col span="10">
          <FormItem prop="projectFid" label="项目名称">
            <Select v-model="searchData.projectFid" placeholder="请选择" @on-change="getZo">
              <Option value=''>请选择</Option>
              <Option v-for="(item,index) in projectList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="10">
          <FormItem prop="activityName" label="活动名称">
            <Input v-model="searchData.activityName" type="text" placeholder="请选择"></Input>
          </FormItem>
        </Col>
        <Col span="10">
          <FormItem prop="activityDate" label="活动时间">
            <Date-picker type="date" style="width:210px" v-model="searchData.activityDate" placeholder="请选择"></Date-picker>
          </FormItem>
        </Col>
      </Row>
      </Form>
      <Form
        :ref="'form'+index"
        :model="itemP" 
        :rules="ruleValidate2"
        :label-width="100"
        v-for="(itemP,index) in activityTypeDtos"
        :key="'index2'+index"
      >
        <Row class="max64">
          <Col span="10">
            <FormItem prop="typeCode" label="活动流程">
              <Select v-model="itemP.typeCode" placeholder="请选择" @on-change="getTypeName">
                <Option value=''>请选择</Option>
                <Option v-for="(item,index) in activityList" :key="'s1'+index" :value="item.typeCode">{{item.typeName}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="10">
            <FormItem prop="zoCodes" label="参与人">
              <Select v-model="itemP.zoCodes" placeholder="请选择" multiple>
                <Option v-for="(item,index) in zoList" :key="'s2'+index" :value="item.value">{{item.label}}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col span="4"  v-if="!index">
            <a style="line-height:32px;margin-left:10px" @click.stop="addItem"> + 添加</a>
          </Col>
          <Col span="4" v-if="index">
            <a style="line-height:32px;margin-left:10px" @click.stop="deleteItem(itemP,index)"> 删除</a>
          </Col>
        </Row>
      </Form>

      <Form
      :label-width="100"
      >
      <Row>
        <Col span="20">
          <FormItem label="描述">
            <Input type="textarea" v-model="searchData.descript"></Input>
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span="20">
          <FormItem label="附件">
            <Col v-if="imagesDtos" v-for="(item,index) in imagesDtos" :key="'i1'+index">
              <img class="upload" :src="item.imgUrl">
              <Button size="small" style="margin-bottom: 20px;" @click="deleteImg(index)">删除</Button>
            </Col>
           <Upload
            class="upload"
            :action="baseUrl+'/file/uploadFile'"
            :on-success="handleSuccess"
            :headers="{'Access-Token':token}"
            :show-upload-list="false"
            :on-error="handleError"
            :format="['jpg','jpeg','png']"
            :on-format-error="formatError"
            icon="ios-cloud-upload-outline"
           >
           <Icon type="ios-plus-empty" size="80" style="vertical-align: middle"></Icon>
          </Upload>
          </FormItem>
        </Col>
      </Row>
    </Form>
  </Modal>
</template>

<script>
import {getBaseUrl} from "../../../../../../utils/public";
import {getToken} from "../../../../../../utils/auth";
import { getProjectZos } from 'api/workOrder'
import {addActivity} from 'api/activityManageApi'
import { formatDateTime } from "../../../../../../utils/format";

export default {
  props:{
    n: {
      type: Number,
      default: 0
    },
    projectList:{
      type:Array,
      default(){
        return []
      }
    },
    activityList:{
      type:Array,
      default(){
        return []
      }
    },
  },
  data(){
    const validates2 = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请选择活动时间'));
      } else{
        callback();
      }
    };
    const validates1 = (rule, value, callback) => {
      if (!value[0]) {
        callback(new Error('请选择参与人'));
      } else{
        callback();
      }
    };
    return{
      maxnum:5,
      token:'',
      baseUrl:'',
      isShow: false,
      loading:true,
      zoList:[],
      imagesDtos:[],
      activityTypeDtos :[],
      searchData:{
        projectFid:'',
        projectName:'',
        activityDate:null,
        descript:'',
        activityName:'',
      },
      ruleValidate:{
        projectFid: [
          { required: true, message: '请选择项目名称', trigger: 'change',type:'string'}
        ],
        activityName:[
          { required: true, message: '请输入活动名称', trigger: 'blur'}
        ],
        activityDate:[
          { required: true, message: '请选择活动日期', trigger: 'change', type:'array',validator:validates2}
        ],
      },
      ruleValidate2:{
        typeCode:[
          { required: true, message: '请选择活动流程', trigger: 'change',type:'string'}
        ],
        zoCodes:[
          { required: true, message: '请选择参与人', trigger: 'blur',type:'array'}
        ],
      }
    }
  },
  watch:{
    n(){
      if(this.$refs['form0']){
        this.$refs['form0'][0].resetFields()
      }
      this.$refs['searchData'].resetFields()
      this.activityTypeDtos =[
        {
          typeCode:'', 
          typeName:'',
          zoCodes:[],
          zoNames:[],
        }
      ],
      this.searchData.descript = ''
      this.imagesDtos = []
      this.isShow = true
    },
    
  },
  created() {
    this.baseUrl = getBaseUrl()
    this.token = getToken()
  },
  computed:{
    saveParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      return {
        projectName:this.searchData.projectName,
        projectFid:this.searchData.projectFid,
        activityName:this.searchData.activityName,
        activityDate:f(this.searchData.activityDate),
        descript:this.searchData.descript,
        activityTypeDtos:this.activityTypeDtos,
        imagesDtos:this.imagesDtos,
      }
    }
  },
  methods:{
    cancel(){

    },
    formatError(){
      this.$Message.info('请上传jpg、jpeg、png类型文件')
    },
    handleSuccess(res){
      if(this.imagesDtos.length >= this.maxnum && this.maxnum >0){
        this.$Message.error('最多上传'+this.maxnum+'张图片')
        this.changeLoading();
        return
      }
      this.imagesDtos.push({
        fid:res.data.fid,
        imgUrl:res.data.url
      })
    },
    deleteImg(index){
      this.imagesDtos.splice(index,1)
      console.log(this.imagesDtos)
    },
    handleError(){

    },
    getTypeName(value){
      this.activityTypeDtos.forEach(ele=>{
        this.activityList.forEach(item=>{
          if(ele.typeCode == item.typeCode){
            ele.typeName = item.typeName
            ele.score = item.score
          }
        })
      })
    },
    getZo(value){
      this.projectList.forEach( ele => {
        if(ele.value === value){
          this.searchData.projectName = ele.text
        }
      })
      this.zoList = []
      getProjectZos({
				projectFid:value
			})
			.then( res => {
        let zoList = res.data;
        zoList.forEach( (ele,index)=>{
          ele.label = ele.text
          if(ele.isProjectManager == 0){
            this.zoList.push(ele)
          }
        })
			})
    },
    addItem(){
      this.activityTypeDtos.push(
        {
          typeCode:'', 
          typeName:'',
          zoCodes:[],
          zoNames:[],
        }
      )
    },
    deleteItem(item,index){
      this.$Modal.confirm({
        content: '<p>确认删除？</p>',
        onOk:() => {
          this.activityTypeDtos.splice(index,1)
        }
      })
    },
    ok(){
      let validate = true
      for (let i in this.$refs) {
        if(this.$refs[i] instanceof Array){
          this.$refs[i].forEach(item => {
            item.validate(bool => {
              !bool && (validate = bool)
            })
          })
        }
      }
      this.$refs['searchData'].validate( bool => {
        if(bool){
          this.activityTypeDtos.forEach(ele=>{
            this.zoList.filter((item)=>{
              if(ele.zoCodes.indexOf(item.value) > -1){
                ele.zoNames.push(item.text)
              }
            })
            ele.zoCodes = ele.zoCodes.join(',')
            ele.zoNames = ele.zoNames.join(',')
          })
        } else{
          validate = false
          this.changeLoading();
        }
      })
      if (!validate) {
        this.changeLoading()
        return
      }
      this.save();
    },
    save(){
      const params = {
        ...this.saveParams,
      }
      addActivity(params)
      .then(res=>{
        this.$Message.success('保存成功')
        this.$emit('done')
      })
      .catch( err =>{
        this.$Message.error('保存失败')
      })
      .finally(()=>{
        this.isShow = false
      })
    },
    changeLoading(){
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true
      })
    },
  }
}
</script>

<style scoped>
.upload {
    display: inline-block;
    width: 150px;
    height: 85px;
    border: 1px dashed rgb(220, 220, 220);
    box-sizing: border-box;
    text-align: center;
    line-height: 80px;
  }
</style>